/*
* Dependencies
*/
var $ = require('jquery');
var msgResources = window.msgResources || {};

/**
 * The loader plugin
 * @param {Object} jQuery element object on which the loader plugin will be
 * initialized
 */
var LoadingIndicator = function(parent) {
  var $parent = parent;
  var $el = $('<div class="l-freeze-panel"> \
      <div class="l-loading-panel" tabindex="0"> \
        <div class="l-icon-container"> \
          <span class="t-loading-icon"></span> \
          <span class="t-loading-icon"></span> \
          <span class="t-loading-icon"></span> \
          <span class="t-loading-icon"></span> \
          <span class="t-loading-icon"></span> \
        </div> \
        <p class="t-loading-text">' + (msgResources.loadingText || 'Loading...') + '</p> \
      </div> \
    </div>');

  /**
   * This function adds the loader overlay to the parent element
   * @param {String} optional param, if set, then it will not add focus to the loading panel.
   * @returns {Boolean} Returns status of the operation success or failure
   */
  this.addLoader = function _addLoader(addFocus) {
    addFocus = addFocus || 'yes';
    if ($parent && $parent.length) {
      $el.appendTo($parent);
      if(addFocus === 'yes') {
        $el.find('.l-loading-panel').focus();
      }
      return true;
    }
    return false;
  };

  /**
   * This function removes the loader overlay from the parent element
   * @returns {Boolean} Returns status of the operation success or failure
   */
  this.removeLoader = function _removeLoader() {
    $el.remove();
    return true;
  };
};

module.exports = LoadingIndicator;
